const recordingS3Bucket = "kemper-s3-prdcnct-connect-voice-recordings-p0";
const recordingPrefix = "/voiceRecording";
export const environment = {
  production: 'true',
  demo: false,
  region: 'us-east-1',
  webDomain: 'https://connectbui.kemper.com',
  version: '1.4',
  identityProvider: 'AzureAD',
  cognitoDomain: 'kemperenterpriseprod',
  cognitoClientId: '4nfrot0vq1p8ase5n23u9fnf9v',
  cognitoUserPoolId: 'us-east-1_BMTN2WH2n',
  identityPoolId: 'us-east-1:e3802b7b-ec43-4b84-8bfa-e3b67f917989',
  authScopes: [
    'phone',
    'email',
    'profile',
    'openid'
  ],
  multilang: true,
  userSearchLambdaName: "kct_p0_prdcnct_cus_userSearch",
  genPresignedUrlLambdaName: "kct_p0_service_ecc_shared_genPresignedUrl",
  userGreetingsLambdaName: "kct_p0_prdcnct_cus_userGreetings",
  getAgentSecurityGroupLambda: "undefined",
  connectUserLambda: "kct_p0_prdcnct_cus_connectUser",
  audioS3BucketDomain: `${recordingS3Bucket}${recordingPrefix}`,
  callHistoryLambda: 'undefined',
  pollyVoiceLambdaName: "kct_p0_prdcnct_ecc2_claims_pollyVoice",
  dynamoLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_bui_config',
  wallboardConfigLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_wb_config',
  wallboardMetricsLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct-p0-prdcnct-ecc-bui-lambda-wb-metrics',
  // New Life Wallboard Lambdas
  lifeWallboardConfigLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_life_wb_config',
  lifeWallboardMetricsLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct-p0-prdcnct-ecc-bui-lambda-life-wb-metrics',

  authzLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_inspect_token',
  FNOLdynamoLambdaName: 'undefined',
  FNOLwallboardConfigLambdaName: 'undefined',
  FNOLwallboardMetricsLambdaName: 'undefined',
  FNOLauthzLambdaName: 'undefined',
  voicemailLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_voicemails',
  CcpConfigLambdaName: "arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_ccpConfig",
  blacklistLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_blacklist',
  hiMarleyCapacityLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct-p0-prdcnct-hiMarley-capacity',
  QueueListLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_queueList',
  pcpRecordingLambdaName: "arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_getRecordingURLs",
  QueuesLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_queues',
  messagesLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_messages',
  getMessageTypesLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_getMessageTypes',
  getLanguagesLambdaName: 'undefined',
  getLOBsLambdaName: 'undefined',
  getBatchIdLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_getBatchId',
  getConnectUsersLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_getConnectUsers',
  createConnectUsersLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_createConnectUsers',
  UpdateConnectUserLambdaName: 'kct_p0_prdcnct_cus_connectUser',
  loadConnectUsersLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_loadConnectUsers',
  GroupsLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_queueGroups',
  holidaysLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_holidays',
  groupMessagesLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_groupMessages',
  QueueMessagesLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_queueMessages',
  ClosureMessagesLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_closureMessages',
  dispositionLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_disposition',
  formatManagementLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_formatManagement',
  formatConnectStringLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_formatConnectString',
  DispositionGroupsLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_dispositionGroups',
  matchManagementLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_matchManagement',
  matchConnectStringLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_matchConnectString',
  connectUtilLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_connectUtil',
  DescribeUserListLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_describeUserList',
  AgentsGetLambdaName: 'kct_p0_prdcnct_voicemail_fn_agentsGet',
  AgentsUpdateByIdLambdaName: 'kct_p0_prdcnct_voicemail_fn_agentsUpdateById',
  ConnectSyncLambdaName: 'kct_p0_prdcnct_voicemail_fn_connectSync',
  ConnectSyncRequestLambdaName: 'kct_p0_prdcnct_voicemail_fn_connectSyncRequest',
  VoicemailUsersTableName: 'kct_p0_prdcnct_voicemail_users',
  kemperAgentProfileLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_kemperAgentProfile',
  GetConnectDIDListLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_getConnectDIDList',
  GetAllGroupVoicemailLambdaName: 'kct_p0_prdcnct_voicemail_fn_getAllGroupVoicemail',
  DeleteGroupVoicemailLambdaName: 'kct_p0_prdcnct_voicemail_fn_deleteGroupVoicemail',
  UpdateGroupVoicemailLambdaName: 'kct_p0_prdcnct_voicemail_fn_updateGroupVoicemail',
  AgentOverflowBatchLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_agentOverflowBatch',
  AgentOverflowRecordLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_agentOverflowRecord',
  VoicemailExtensionRecordLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_voicemailExtensionRecord',
  GetOverflowBatchIdLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_getOverflowBatchId',
  GetBatchListLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_getBatchList',
  ContactTraceRecordLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_contactTraceRecord',
  SpecialMessageDataLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_specialMessageDataHandler',
  SpecialMessageTypeDataLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_specialMessageTypeDataHandler',
  ApplicationDataLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_applicationData',
  CampaignLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_dnisHandler',
  ANIConfigLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_aniHandler',
  quickConnectLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_reports_getQuickConnects',
  reportGetQueuesLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_reports_getQueues',
  presetMessageLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_bui_presetMessageHandler',
  GetContactFlowReportLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_reports_getContactFlowReport',
  AdvancedNotificationLambdaName: 'arn:aws:lambda:us-east-1:866772668540:function:kct_p0_prdcnct_ecc_advanced_notification_getAdvNotification',
  authRoles: {
    health: 'Health',
    fnol: 'fnol',
    life: 'Life',
    claims: 'Claims',
    auto: 'Auto',
    hr: 'Hr',
    it: 'It',
    pnc: 'Pnc',
    insidesales: 'Insidesales',
    fnolConfig: "DNISAdmin",
    fnolWallboard: "WBConfig",
    healthConfig: 'DNISAdminHealth',
    healthWallboard: 'WBConfigHealth',
    lifeConfig: 'DNISAdminLife',
    lifeWallboard: 'WBConfigLife',
    claimsConfig: 'DNISAdminClaims',
    claimsWallboard: 'WBConfigClaims',
    autoConfig: 'AutoAdmin',
    autoWallboard: 'AutoWBConfig',
    hrConfig: 'DNISAdminHr',
    hrWallboard: 'WBConfigHr',
    pncConfig: 'DNISAdminPnc',
    pncWallboard: 'WBConfigPnc',
    insidesalesConfig: 'DNISAdminInsidesales',
    insidesalesWallboard: 'WBConfigInsidesales',
    itConfig: 'DNISAdminIt',
    itWallboard: 'WBConfigIt',
    telecom: 'BUITelecom',
    ctr: 'BUICtr',
    policySearch: 'PSearch',
    claimSearch: 'CSearch',
    specialMsg: "BUIMsgUser",
    specialMsgSuper: "BUIMsgSup",
    DNISConfig: "CamMgmt",
    ANIConfig: "ANIConfig",
    buiManager: "buiManager",
    aaccConfig: 'DNISAdminClaims',
    aaccWallboard: 'WBConfigClaims',
  },
  roles: {
    health: {
      main: 'Health',
      config: 'DNISAdminHealth',
      wb: 'WBConfigHealth'
    },
    life: {
      main: 'Life',
      config: 'DNISAdminLife',
      wb: 'WBConfigLife'
    },
    fnol: {
      main: 'fnol',
      config: 'DNISAdmin',
      wb: 'WBConfig'
    },
    auto: {
      main: 'Auto',
      config: 'AutoAdmin',
      wb: 'AutoWBConfig'
    },
    claims: {
      main: 'Claims',
      config: 'DNISAdminClaims',
      wb: 'WBConfigClaims'
    },
    hr:{
      main: 'Hr',
      config: 'DNISAdminHr',
      wb: 'WBConfigHr',
    },
    pnc:{
      main: 'Pnc',
      config: 'DNISAdminPnc',
      wb: 'WBConfigPnc',
    },
    insidesales:{
      main: 'Insidesales',
      config: 'DNISAdminInsidesales',
      wb: 'WBConfigInsidesales',
    },
    it:{
      main: 'It',
      config: 'DNISAdminIt',
      wb: 'WBConfigIt',
    },
    aacc:{
      main: 'Claims',
      config: 'DNISAdminClaims',
      wb: 'WBConfigClaims',
    },
    telecom: 'BUITelecom',
    ctr: 'BUICtr'
  }
};
